import React from "react";

const Money = props => {
  if (props.value == null && props.cents == null) {
    return <span>- €</span>;
  }

  const value =
    props.cents != null ? Math.round(props.cents) / 100 : props.value;

  const roundedValue = props.absolute
    ? Math.round(value)
    : Math.round(value * 100) / 100;

  const formattedValue = roundedValue.toFixed(props.absolute ? 0 : 2);

  return <span>{`${formattedValue} €`.replace(".", ",")}</span>;
};

export default Money;
